import { ReactNode, Suspense } from "react";
import { Provider } from "react-redux";
import { HistoryRouter as Router } from "redux-first-history/rr6";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { history, store } from "../../redux/configureStore";

interface Props {
  children: ReactNode;
}

function ReduxProvider(props: Props) {
  // let store: Store;

  // Création du store Redux
  const initialState = {};
  // const { store } = configureStore(initialState);

  let persistor = persistStore(store);

  return (
    <Provider store={store}>
      <Suspense fallback={<div>ah ?</div>}>
        <PersistGate loading={null} persistor={persistor}>
          <Router history={history}>{props.children}</Router>
        </PersistGate>
      </Suspense>
    </Provider>
  );
}

export default ReduxProvider;
